import React from 'react';
import { useTranslation } from 'react-i18next';

import { BusinessApp } from '@/modules/Onboarding/components/ConnectEcoSystem/BusinessApp';
import { FieldApp } from '@/modules/Onboarding/components/ConnectEcoSystem/FieldApp';
import { Typography } from '@/shared/components/atoms';

const ConnectEcoSystemModal = () => {
  const { t } = useTranslation('navigation');

  return (
    <div>
      <Typography weight='bold' className='w-full text-center' variant='h2'>
        {t('connect-ecosystem')}
      </Typography>
      <BusinessApp flex='flex-row-reverse' />
      <div className='my-24 w-full border-b-xs border-b-neutralVariant-90'></div>
      <FieldApp flex='flex-row' />
    </div>
  );
};

export { ConnectEcoSystemModal };
